import { Injectable } from '@angular/core'
import { StaticMenuItem } from '@ftr/menus'
import { NavItemsProvider } from '@ftr/ui-core'
import { Observable, of } from 'rxjs'
import { GlobalNavItems } from './global-nav-items'

@Injectable({
  providedIn: 'root',
})
export class AccountMenuItemsProvider implements NavItemsProvider {
  constructor(private readonly globalNavItems: GlobalNavItems) {}

  provide(): Observable<StaticMenuItem[]> {
    return of([this.globalNavItems.logout()])
  }
}
